
import { useUserManagement } from "@/hooks/useUserManagement";
import { UsersHeader } from "./UsersHeader";
import { UsersFilter } from "./UsersFilter";
import { UsersTable } from "./UsersTable";
import { CreateUserDialog } from "./CreateUserDialog";
import { DeleteUserDialog } from "./DeleteUserDialog";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Lock } from "lucide-react";

export function Users() {
  const { subscriptionData } = useAuth();
  const {
    users,
    loading,
    sortColumn,
    sortDirection,
    filter,
    createDialogOpen,
    deleteDialogOpen,
    currentUserEdit,
    isSaving,
    isDeleting,
    setFilter,
    setCreateDialogOpen,
    handleSort,
    handleDelete,
    handleCreateUser,
    handleConfirmDelete
  } = useUserManagement();

  // Verificar se o usuário pode acessar o gerenciamento de usuários
  const canAccessUsers = subscriptionData.subscription_tier && 
                        subscriptionData.subscription_tier !== 'FREE' && 
                        subscriptionData.is_owner;

  if (!canAccessUsers) {
    return (
      <Card>
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
            <Lock className="h-6 w-6 text-muted-foreground" />
          </div>
          <CardTitle>Acesso Restrito</CardTitle>
          <CardDescription>
            O gerenciamento de usuários está disponível apenas para proprietários de assinaturas pagas.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-sm text-muted-foreground">
            Para gerenciar usuários da sua organização, você precisa ser o proprietário de uma assinatura ativa diferente do plano FREE.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <UsersHeader onNewUser={() => setCreateDialogOpen(true)} />
      
      <UsersFilter filter={filter} onFilterChange={setFilter} />
      
      <UsersTable
        users={users}
        loading={loading}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        onSort={handleSort}
        onDelete={handleDelete}
      />

      <CreateUserDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
        onConfirm={handleCreateUser}
        isLoading={isSaving}
      />

      <DeleteUserDialog
        open={deleteDialogOpen}
        onOpenChange={(open) => !open && handleDelete(null)}
        onConfirm={handleConfirmDelete}
        user={currentUserEdit}
        isLoading={isDeleting}
      />
    </div>
  );
}
